import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/components/legal/legal-page";
import { TERMS } from "@/lib/legal";

export const Route = createFileRoute("/terms")({
  component: () => <LegalPage doc={TERMS} />,
});
